import { useState, useEffect } from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  Center,
  Icon,
} from '@chakra-ui/react';
import { EmailIcon } from '@chakra-ui/icons';
import AuthLayout from '../components/auth/AuthLayout';

const EmailVerificationPage = () => {
  const [email, setEmail] = useState('');

  // Get email from localStorage
  useEffect(() => {
    const storedEmail = localStorage.getItem('pendingVerificationEmail');
    if (storedEmail) {
      setEmail(storedEmail);
    }
  }, []);

  return (
    <AuthLayout title="Check Your Email">
      <Center minH="60vh">
        <VStack spacing={6} maxW="md" w="full" align="center" textAlign="center">
          <Box 
            w="70px" 
            h="70px" 
            borderRadius="full" 
            bg="blue.100" 
            display="flex" 
            alignItems="center" 
            justifyContent="center"
          >
            <Icon as={EmailIcon} w={8} h={8} color="blue.500" />
          </Box>
          
          <Box>
            <Heading size="md" mb={2}>Verification Email Sent</Heading>
            {email ? (
              <Text color="gray.600">
                We've sent a verification link to <strong>{email}</strong>
              </Text>
            ) : (
              <Text color="gray.600">
                We've sent a verification link to your email address.
              </Text>
            )}
            <Text mt={2} color="gray.600">
              Please check your inbox and click the link to complete your account setup.
            </Text>
            <Text mt={2} fontSize="sm" color="gray.500">
              Be sure to check your spam or junk folder if you don't see it in your inbox.
            </Text>
          </Box>
          
          <Text fontSize="sm" color="gray.500" mt={2}>
            The verification link will open in a new tab and will guide you through the setup process.
          </Text>
        </VStack>
      </Center>
    </AuthLayout>
  );
};

export default EmailVerificationPage;
